import EventEmitter from 'eventemitter3';

import { makeToastBuilder } from './utils/makeToastBuilder';

export enum ToastEventType {
  SHOW_TOAST = 'show-toast',
}

export const ToastEmitter = new EventEmitter();

export const toast = makeToastBuilder((p) => ToastEmitter.emit(ToastEventType.SHOW_TOAST, p));
